
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IuC4leC4seC5ieC4h%2BC4hOC5iOC4suC4geC4suC4o%2BC4oeC4reC4h%2BC5gOC4q%2BC5h%2BC4mSJ9!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IuC4leC4seC5ieC4h%2BC4hOC5iOC4suC4geC4suC4o%2BC4oeC4reC4h%2BC5gOC4q%2BC5h%2BC4mSJ9!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IkF0dXIgdmlzaWJpbGl0YXMifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IkF0dXIgdmlzaWJpbGl0YXMifQ%3D%3D!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IuC4leC4seC5ieC4h%2BC4hOC5iOC4suC4geC4suC4o%2BC4oeC4reC4h%2BC5gOC4q%2BC5h%2BC4mSJ9!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IuC4leC4seC5ieC4h%2BC4hOC5iOC4suC4geC4suC4o%2BC4oeC4reC4h%2BC5gOC4q%2BC5h%2BC4mSJ9!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IkF0dXIgdmlzaWJpbGl0YXMifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IkF0dXIgdmlzaWJpbGl0YXMifQ%3D%3D!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlNldCB2aXNpYmlsaXR5In0%3D!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlvFoOG6veG6veG5ryDhub3DrMOsxaHDrMOsw5%2FDrMOsxprDrMOs4bmvw73DvV0ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZXQgdmlzaWJpbGl0eSI6IlvFoOG6veG6veG5ryDhub3DrMOsxaHDrMOsw5%2FDrMOsxprDrMOs4bmvw73DvV0ifQ%3D%3D!"
        )
      )
      });
  
      export { translations as default };
    